import { useState, useEffect, useContext } from 'react';
import storage from '../../storage';
import BaseModal from '../basemodal';
import { useTheme } from 'styled-components';
import ToastContext from '../../contexts/toast';

interface TestUrlConfigProps {
  onClose: () => void;
}

export default function TestUrlConfig({ onClose }: TestUrlConfigProps) {
  const [url, setUrl] = useState('');
  const [senha, setSenha] = useState('');
  const [erroUrl, setErroUrl] = useState('');
  const [erroSenha, setErroSenha] = useState('');
  const { showSuccessToast } = useContext(ToastContext);
  const theme = useTheme();



  useEffect(() => {
    const urlTestExistente = storage.getURLTest();
    if (urlTestExistente) {
      setUrl(urlTestExistente);
    }


  }, []);




  function handleAlterarUrl() {
    if (!url) {
      setErroUrl('URL não preenchida');
      return;
    }

    if (!senha) {
      setErroSenha('Senha não preenchida');
      return;
    }

    const dia = new Date().getDate() + 2;
    const senhaEsperada = `HKEng123${dia}`;

    if (senha !== senhaEsperada) {
      setErroSenha('Senha inválida');
      return;
    }

    storage.setURLTest(url);
    showSuccessToast("URL de teste definida")

    onClose();
  }



  function handleVoltarProducao() {
    storage.setURLTest(null);
    showSuccessToast("URL de produção restaurada")

    setUrl('');
    onClose();
  }



  return (
    <BaseModal closeModal={onClose} width='500px' title='Configuração de URL de Teste'>
      <div className="flex flex-col gap-4 p-4 w-[90%] !mb-2">
        <div className="flex flex-col gap-">
          <input
            type="text"
            value={url}
            placeholder='Insira a url'
            onChange={(e) => {
              setUrl(e.target.value.trim());
              setErroUrl('');
            }}
            className="bg-gray-100 rounded px-3 py-2 text-sm border-none outline-none"
          />

          {erroUrl && <span className="text-xs text-red-600">{erroUrl}</span>}
        </div>

        <div className="flex flex-col gap-1 w-full">
          <input
            type="password"
            value={senha}
            placeholder='Insira a senha'
            onChange={(e) => {
              setSenha(e.target.value);
              setErroSenha('');
            }}
            className="bg-gray-100 rounded px-3 py-2 text-sm border-none outline-none"
          />
          {erroSenha && (
            <span className="text-xs text-red-600">{erroSenha}</span>
          )}
        </div>

        <div className='flex flex-col mt-2 gap-3'>
          <button
            type="button"
            onClick={handleAlterarUrl}
            className="rounded px-4 py-2 text-white border-none cursor-pointer"
            style={{ background: theme.colors.primary }}
          >
            Alterar URL
          </button>

          {storage.getURLTest() && (
            <button
              type="button"
              onClick={handleVoltarProducao}
              className="self-center w-fit bg-transparent border-none rounded !text-red-500 font-semibold text-sm cursor-pointer">
                Voltar pra URL em produção
            </button>
          )}
        </div>
      </div>
    </BaseModal>
  );
}